export default "__VITE_ASSET__ByzHzWHg__"